import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormControl, FormGroup } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { Location } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { LogAgendaFinanceiraService } from './log-agenda-financeira.service';
import { ActivatedRoute } from '@angular/router';
import { EncriptyUtilService } from '../../../../shared/services/encripty-util.service';
import { DocumentoHelper } from '../../../../shared/utils/documento.helper';

@Component({
  selector: 'ngx-log-agenda-financeira',
  templateUrl: './log-agenda-financeira.component.html',
  styleUrls: ['./log-agenda-financeira.component.scss']
})
export class LogAgendaFinanceiraComponent implements OnInit {

  public formLogAgendaFinanceira = null;
  public isTed = false;
  public isBoleto = false;
  public isRecarga = false;
  public cnpjCpf = null;
  public id = null;
  public customLogin = null;


  constructor(
    private formBuilder: FormBuilder,
    private location: Location,
    private service: LogAgendaFinanceiraService,
    private notificationService: NotificationsService,
    private spinnerService: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private encriptyService: EncriptyUtilService,

  ) {
    this.activatedRoute.queryParams.subscribe(register => {

      this.id = this.encriptyService.decriptyBySecretKey(register.id);

      let params = new HttpParams();

      if (this.id != null) {
        params = params.append('id', this.id)
      }

      this.service.logMonitoramento(params, (response => {

        this.formLogAgendaFinanceira.controls['cartaoPrePagoId'].setValue(response.content[0].cartaoPrePagoId);
        this.formLogAgendaFinanceira.controls['cartaoPrePagoValor'].setValue(response.content[0].cartaoPrePagoIdValor);
        this.formLogAgendaFinanceira.controls['parcelados'].setValue(response.content[0].recebiveisMaiores30dias);
        this.formLogAgendaFinanceira.controls['proximos30dias'].setValue(response.content[0].recebiveisMenores30dias);
        this.formLogAgendaFinanceira.controls['jsonChamado'].setValue(response.content[0].jsonChamado);
        this.formLogAgendaFinanceira.controls['jsonRetorno'].setValue(response.content[0].jsonRetorno);
        this.formLogAgendaFinanceira.controls['editavelBackoffice'].setValue(response.content[0].editavelBackoffice);

        if (response.content[0].tipoOperacao === 'TRANSFERENCIA') {

          this.formLogAgendaFinanceira.controls['nomeBanco'].setValue(response.content[0].nomeBanco);
          this.formLogAgendaFinanceira.controls['codigoBanco'].setValue(response.content[0].codigoBanco);
          this.formLogAgendaFinanceira.controls['agencia'].setValue(response.content[0].agencia);
          this.formLogAgendaFinanceira.controls['conta'].setValue(response.content[0].contaComDigito);
          this.formLogAgendaFinanceira.controls['destinatario'].setValue(response.content[0].nome);
          this.formLogAgendaFinanceira.controls['cpfCnpj'].setValue(response.content[0].cpfCnpj);
          this.formLogAgendaFinanceira.controls['transactionId'].setValue(response.content[0].transactionId);
          this.formLogAgendaFinanceira.controls['valor'].setValue(response.content[0].valorOperacao);

          this.isTed = true;
          this.isBoleto = false;
          this.isRecarga = false;

        } else if (response.content[0].tipoOperacao === 'BOLETO') {

          this.formLogAgendaFinanceira.controls['transactionIdBoleto'].setValue(response.content[0].transactionId);
          this.formLogAgendaFinanceira.controls['linhaDigitavel'].setValue(response.content[0].linhaDigitavel);
          this.formLogAgendaFinanceira.controls['valorOriginal'].setValue(response.content[0].valorOperacao);
          this.formLogAgendaFinanceira.controls['valorAtualizado'].setValue(response.content[0].valorBoleto);

          this.isBoleto = true;
          this.isTed = false;
          this.isRecarga = false;

        } else if (response.content[0].tipoOperacao === 'RECARGA') {

          this.formLogAgendaFinanceira.controls['valorRecarga'].setValue(response.content[0].valorOperacao);
          this.formLogAgendaFinanceira.controls['numeroTelefone'].setValue(response.content[0].numeroTelefone);
          this.formLogAgendaFinanceira.controls['transactionIdRecarga'].setValue(response.content[0].transactionId);
          this.formLogAgendaFinanceira.controls['operadora'].setValue(response.content[0].descricaoOperadora);

          this.isRecarga = true;
          this.isTed = false;
          this.isBoleto = false;

        }

      }), error => {

        null;

      });
    });
  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.formLogAgendaFinanceira = this.formBuilder.group({

      cartaoPrePagoId: [null],
      cartaoPrePagoValor: [null],
      parcelados: [null],
      proximos30dias: [null],
      nomeBanco: [null],
      codigoBanco: [null],
      destinatario: [null],
      valor: [null],
      transactionId: [null],
      cpfCnpj: [null],
      linhaDigitavel: [null],
      valorOriginal: [null],
      transactionIdBoleto: [null],
      operadora: [null],
      valorRecarga: [null],
      transactionIdRecarga: [null],
      agencia: [null],
      conta: [null],
      valorAtualizado: [null],
      numeroTelefone: [null],
      jsonChamado: [null],
      jsonRetorno: [null],
      editavelBackoffice: [null],
      parecer: [null, Validators.required]
    });

  }

  getCpfCnpjMask(): string {
    return DocumentoHelper.getMascaraCpfCnpj(this.cnpjCpf);
  }

  previousPage() {

    this.location.back();

  }

  gotoVoltar() {
    this.location.back();
  }

  gotoReprocessar(data) {
    if (!this.formLogAgendaFinanceira.valid) {
      this.validateAllFormFields(this.formLogAgendaFinanceira);
      return;
    }
    this.mudarStatus(data, "REPROCESSAR");
  }

  gotoEstornar(data) {
    if (!this.formLogAgendaFinanceira.valid) {
      this.validateAllFormFields(this.formLogAgendaFinanceira);
      return;
    }
    this.mudarStatus(data, "ESTORNAR");
  }

  gotoConfirmar(data) {
    if (!this.formLogAgendaFinanceira.valid) {
      this.validateAllFormFields(this.formLogAgendaFinanceira);
      return;
    }
    this.mudarStatus(data, "FINALIZAR");
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  mudarStatus(data: any, novoStatus: string) {
    let mudancaStatusBody = {
      scheduleId: this.id,
      parecer: data.parecer,
      novoStatus
    }

    this.spinnerService.show();
    this.service.mudarStatus(mudancaStatusBody, (_response => {
      this.spinnerService.hide();
      this.notificationService.success('Status alterado com sucesso.');
    }), error => {
      this.spinnerService.hide();
      this.notificationService.error(error.message);
    });
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }
}
